// Скопировано из clown-back через `pnpm api`. Не править руками.
// Code generated by tygo. DO NOT EDIT.

//////////
// source: card.go
/*
Package game содержит эталонную реализацию правил «Клоуна».

Пакет детерминирован по построению: он не обращается к БД, сети, файлам,
os, time.Now() и глобальному rand. Всё внешнее приходит параметрами.
Это нужно не ради портируемости, а ради того, чтобы нативный клиент со
своей реализацией правил мог сверяться с векторами из testdata/vectors
побайтово. Любая недетерминированная деталь ломает саму возможность сверки.
*/

/**
 * Deck — категория карточек.
 */
export type Deck = string;
/**
 * Категории карточек.
 */
export const DeckTruth: Deck = "truth";
/**
 * Категории карточек.
 */
export const DeckAction: Deck = "action";
/**
 * Категории карточек.
 */
export const DeckDrink: Deck = "drink";
/**
 * Категории карточек.
 */
export const DeckClown: Deck = "clown";
/**
 * TargetType — способ выбрать адресата задания.
 */
export type TargetType = string;
/**
 * Способы адресации.
 */
export const TargetSelf: TargetType = "self";
/**
 * Способы адресации.
 */
export const TargetAll: TargetType = "all";
/**
 * Способы адресации.
 */
export const TargetRelative: TargetType = "relative";
/**
 * Способы адресации.
 */
export const TargetOpposite: TargetType = "opposite";
/**
 * Способы адресации.
 */
export const TargetRandom: TargetType = "random";
/**
 * Способы адресации.
 */
export const TargetChoice: TargetType = "choice";
/**
 * Способы адресации.
 */
export const TargetGender: TargetType = "gender";
/**
 * Requirement — реквизит или механика, без которых карточку не сыграть.
 */
export type Requirement = string;
/**
 * Реквизиты.
 */
export const ReqTimer: Requirement = "timer";
/**
 * Реквизиты.
 */
export const ReqCoin: Requirement = "coin";
/**
 * Реквизиты.
 */
export const ReqDice: Requirement = "dice";
/**
 * Реквизиты.
 */
export const ReqCamera: Requirement = "camera";
/**
 * Реквизиты.
 */
export const ReqRandomizer: Requirement = "randomizer";
/**
 * Реквизиты.
 */
export const ReqMinigame: Requirement = "minigame";
/**
 * GenderMatch — как соотносится пол адресата с полом активного игрока.
 */
export type GenderMatch = string;
/**
 * Соотношения полов для адресации.
 */
export const GenderSame: GenderMatch = "same";
/**
 * Соотношения полов для адресации.
 */
export const GenderOpposite: GenderMatch = "opposite";
/**
 * Target описывает, кому адресовано задание карточки.
 */
export interface Target {
  type: TargetType;
  offset?: number /* int */; // -1 слева, +1 справа
  value?: GenderMatch; // только для type=gender
}
/**
 * Card — карточка задания.
 */
export interface Card {
  id: string;
  deck: Deck;
  text: string; // авторский текст, может содержать {target}
  target?: Target;
  requires?: Requirement[];
  duration?: number /* int */;
  minigame?: string;
  intensity: number /* int */; // 1 мягко, 3 колода «Клоун»
  minPlayers?: number /* int */;
  tags?: string[];
  secret?: boolean; // текст виден только исполнителю
}
/**
 * TargetPlaceholder — подстановка имени адресата в тексте карточки.
 * Механизм опциональный (ADR-0007): карточка с Target не обязана содержать
 * плейсхолдер, и в боевом контенте не содержит. Текст — авторский и дословный,
 * адресата рисует клиент по Pending.TargetSeats и Card.Target. Подстановка
 * остаётся для карточек, которые под неё написаны («Пьёт: {target}»): в
 * русском она даёт имя в именительном падеже и годится не везде.
 */
export const TargetPlaceholder = "{target}";

//////////
// source: command.go

/**
 * CommandType — намерение игрока.
 * Клиент шлёт только намерения. Никаких «примени вот это состояние»:
 * решение принимает сервер, клиент не источник истины.
 */
export type CommandType = string;
/**
 * Типы команд.
 */
export const CommandStart: CommandType = "start";
/**
 * Типы команд.
 */
export const CommandDraw: CommandType = "draw";
/**
 * Типы команд.
 */
export const CommandPickTarget: CommandType = "pick_target";
/**
 * Типы команд.
 */
export const CommandComplete: CommandType = "complete";
/**
 * Типы команд.
 */
export const CommandSkip: CommandType = "skip";
/**
 * Типы команд.
 */
export const CommandUseRescuer: CommandType = "use_rescuer";
/**
 * Типы команд.
 */
export const CommandFinish: CommandType = "finish";
/**
 * Command — намерение конкретного игрока.
 * Actor — место, от имени которого действуют. В hotseat одно соединение
 * владеет всеми местами, поэтому право проверяется как «отправитель владеет
 * местом активного игрока», а не «отправитель и есть активный игрок».
 * Эта проверка живёт в комнате; здесь проверяется только смысл действия.
 */
export interface Command {
  type: CommandType;
  actor: PlayerID;
  seat?: number /* int */; // цель для pick_target и use_rescuer
}

//////////
// source: deck.go

/**
 * DeckSet — версионированный бандл карточек целиком.
 */
export interface DeckSet {
  version: string;
  minigames?: string[];
  cards: Card[];
}

//////////
// source: event.go

/**
 * EventType — тип события журнала.
 */
export type EventType = string;
/**
 * Типы событий.
 * События — единственный источник истины для восстановления партии:
 * в БД есть только append-only game_events, снапшота состояния нет.
 * Поэтому событие обязано нести всё, что нужно, чтобы применить его без
 * ГПСЧ: результат тасовки — списком, результат броска кубика — числом.
 */
export const EventGameStarted: EventType = "game_started";
/**
 * Типы событий.
 * События — единственный источник истины для восстановления партии:
 * в БД есть только append-only game_events, снапшота состояния нет.
 * Поэтому событие обязано нести всё, что нужно, чтобы применить его без
 * ГПСЧ: результат тасовки — списком, результат броска кубика — числом.
 */
export const EventDeckShuffled: EventType = "deck_shuffled";
/**
 * Типы событий.
 * События — единственный источник истины для восстановления партии:
 * в БД есть только append-only game_events, снапшота состояния нет.
 * Поэтому событие обязано нести всё, что нужно, чтобы применить его без
 * ГПСЧ: результат тасовки — списком, результат броска кубика — числом.
 */
export const EventDiceRolled: EventType = "dice_rolled";
/**
 * Типы событий.
 * События — единственный источник истины для восстановления партии:
 * в БД есть только append-only game_events, снапшота состояния нет.
 * Поэтому событие обязано нести всё, что нужно, чтобы применить его без
 * ГПСЧ: результат тасовки — списком, результат броска кубика — числом.
 */
export const EventPawnMoved: EventType = "pawn_moved";
/**
 * Типы событий.
 * События — единственный источник истины для восстановления партии:
 * в БД есть только append-only game_events, снапшота состояния нет.
 * Поэтому событие обязано нести всё, что нужно, чтобы применить его без
 * ГПСЧ: результат тасовки — списком, результат броска кубика — числом.
 */
export const EventDeckSelected: EventType = "deck_selected";
/**
 * Типы событий.
 * События — единственный источник истины для восстановления партии:
 * в БД есть только append-only game_events, снапшота состояния нет.
 * Поэтому событие обязано нести всё, что нужно, чтобы применить его без
 * ГПСЧ: результат тасовки — списком, результат броска кубика — числом.
 */
export const EventCardDrawn: EventType = "card_drawn";
/**
 * Типы событий.
 * События — единственный источник истины для восстановления партии:
 * в БД есть только append-only game_events, снапшота состояния нет.
 * Поэтому событие обязано нести всё, что нужно, чтобы применить его без
 * ГПСЧ: результат тасовки — списком, результат броска кубика — числом.
 */
export const EventTargetPicked: EventType = "target_picked";
/**
 * Типы событий.
 * События — единственный источник истины для восстановления партии:
 * в БД есть только append-only game_events, снапшота состояния нет.
 * Поэтому событие обязано нести всё, что нужно, чтобы применить его без
 * ГПСЧ: результат тасовки — списком, результат броска кубика — числом.
 */
export const EventRescuerUsed: EventType = "rescuer_used";
/**
 * Типы событий.
 * События — единственный источник истины для восстановления партии:
 * в БД есть только append-only game_events, снапшота состояния нет.
 * Поэтому событие обязано нести всё, что нужно, чтобы применить его без
 * ГПСЧ: результат тасовки — списком, результат броска кубика — числом.
 */
export const EventRescuerGranted: EventType = "rescuer_granted";
/**
 * Типы событий.
 * События — единственный источник истины для восстановления партии:
 * в БД есть только append-only game_events, снапшота состояния нет.
 * Поэтому событие обязано нести всё, что нужно, чтобы применить его без
 * ГПСЧ: результат тасовки — списком, результат броска кубика — числом.
 */
export const EventCardCompleted: EventType = "card_completed";
/**
 * Типы событий.
 * События — единственный источник истины для восстановления партии:
 * в БД есть только append-only game_events, снапшота состояния нет.
 * Поэтому событие обязано нести всё, что нужно, чтобы применить его без
 * ГПСЧ: результат тасовки — списком, результат броска кубика — числом.
 */
export const EventCardSkipped: EventType = "card_skipped";
/**
 * Типы событий.
 * События — единственный источник истины для восстановления партии:
 * в БД есть только append-only game_events, снапшота состояния нет.
 * Поэтому событие обязано нести всё, что нужно, чтобы применить его без
 * ГПСЧ: результат тасовки — списком, результат броска кубика — числом.
 */
export const EventTurnAdvanced: EventType = "turn_advanced";
/**
 * Типы событий.
 * События — единственный источник истины для восстановления партии:
 * в БД есть только append-only game_events, снапшота состояния нет.
 * Поэтому событие обязано нести всё, что нужно, чтобы применить его без
 * ГПСЧ: результат тасовки — списком, результат броска кубика — числом.
 */
export const EventGameFinished: EventType = "game_finished";
/**
 * Event — запись журнала партии.
 * Плоская структура с omitempty вместо интерфейса-объединения: так JSON
 * стабилен и одинаково читается на любой платформе, а векторы соответствия
 * сравниваются побайтово.
 */
export interface Event {
  type: EventType;
  deck?: Deck;
  order?: string[]; // результат тасовки очереди
  cardId?: string;
  seat?: number /* int */;
  targetSeats?: number /* int */[];
  fromSeat?: number /* int */;
  toSeat?: number /* int */;
  turn?: number /* int */;
  dice?: number /* int */;
  fromCell?: number /* int */;
  toCell?: number /* int */;
}

//////////
// source: redact.go

/**
 * PublicState — партия глазами одного игрока.
 * Наружу уходит только это. Полный State не рассылается никогда: в нём лежат
 * сид и очереди, то есть весь будущий расклад. Отправив его «для удобства»,
 * мы отдадим клиенту возможность подсмотреть игру вперёд.
 */
export interface PublicState {
  schema: number /* int */;
  deckVersion: string;
  boardVersion?: string;
  settings: PublicSettings;
  viewer: PlayerID;
  /**
   * ViewerSeat отсутствует у зрителя, которого нет за столом. Раньше здесь
   * был int, и наблюдатель получал 0 — то есть контракт сообщал ему, что он
   * сидит на месте хоста.
   */
  viewerSeat?: number /* int */;
  players: PublicPlayer[];
  activeSeat: number /* int */;
  turn: number /* int */;
  phase: Phase;
  pending?: PublicPending;
  remaining: { [key: Deck]: number /* int */};
}
/**
 * PublicSettings — настройки партии, какими их видит клиент.
 * Отдельный тип, а не game.Settings: доменная структура растёт под нужды
 * правил, и новое поле в ней уезжало бы клиенту без единой правки здесь.
 * Редакция обязана быть явной, поэтому поля копируются поимённо.
 */
export interface PublicSettings {
  mode: Mode;
  maxIntensity: number /* int */;
}
/**
 * PublicPlayer — игрок, каким его видят остальные.
 */
export interface PublicPlayer {
  id: PlayerID;
  name: string;
  gender: Gender;
  seat: number /* int */;
  rescuers: number /* int */;
  victims: number /* int */;
  position: number /* int */;
}
/**
 * PublicPending — карточка на столе, как её видит конкретный зритель.
 */
export interface PublicPending {
  deck: Deck;
  assigneeSeat: number /* int */;
  targetSeats?: number /* int */[];
  rescued?: boolean;
  hidden?: boolean; // секретная карточка чужими глазами
  card?: PublicCard;
}
/**
 * PublicCard — карточка без служебных полей.
 */
export interface PublicCard {
  id: string;
  deck: Deck;
  text: string;
  target?: Target;
  requires?: Requirement[];
  duration?: number /* int */;
  minigame?: string;
  intensity: number /* int */;
  tags?: string[];
  secret?: boolean;
}

//////////
// source: reducer.go


//////////
// source: state.go

/**
 * StateSchema — версия формы состояния. Растёт при несовместимом изменении
 * полей State: по ней нативная реализация понимает, что вектора не её.
 */
export const StateSchema = 1;
/**
 * Границы размера компании: игра рассчитана на 3–8 человек в одной комнате.
 * MaxRoster продублирован в схеме: миграция 00004_games.sql ограничивает
 * game_players.seat диапазоном 0..7. Менять их надо вместе — иначе база молча
 * отвергнет игрока, которого правила приняли, и обнаружится это при записи
 * состава, то есть на старте партии у живых людей.
 */
export const MinRoster = 3;
/**
 * Границы размера компании: игра рассчитана на 3–8 человек в одной комнате.
 * MaxRoster продублирован в схеме: миграция 00004_games.sql ограничивает
 * game_players.seat диапазоном 0..7. Менять их надо вместе — иначе база молча
 * отвергнет игрока, которого правила приняли, и обнаружится это при записи
 * состава, то есть на старте партии у живых людей.
 */
export const MaxRoster = 8;
/**
 * Gender — пол игрока, нужен только для карточек с адресацией по полу.
 */
export type Gender = string;
/**
 * Значения пола.
 */
export const GenderMale: Gender = "male";
/**
 * Значения пола.
 */
export const GenderFemale: Gender = "female";
/**
 * Значения пола.
 */
export const GenderUnspecified: Gender = "unspecified";
/**
 * PlayerID — идентификатор игрока внутри партии.
 * Это НЕ users.id: в hotseat игроки заводятся хостом и своих аккаунтов
 * не имеют. Связь с пользователем живёт в game_players, а не здесь.
 */
export type PlayerID = string;
/**
 * Mode — способ выбора категории в партии.
 */
export type Mode = string;
/**
 * Режимы выбора категории.
 */
export const ModeFree: Mode = "free"; // взвешенный случайный выбор
/**
 * Режимы выбора категории.
 */
export const ModeBoard: Mode = "board"; // кубик и клетка карты-бродилки; в v1 не реализован
/**
 * Phase — стадия хода.
 */
export type Phase = string;
/**
 * Стадии хода.
 */
export const PhaseLobby: Phase = "lobby";
/**
 * Стадии хода.
 */
export const PhaseDraw: Phase = "awaiting_draw";
/**
 * Стадии хода.
 */
export const PhaseChoice: Phase = "awaiting_choice";
/**
 * Стадии хода.
 */
export const PhaseResolve: Phase = "awaiting_resolution";
/**
 * Стадии хода.
 */
export const PhaseFinished: Phase = "finished";
/**
 * Player — игрок за столом.
 */
export interface Player {
  id: PlayerID;
  name: string;
  gender: Gender;
  seat: number /* int */;
  rescuers: number /* int */;
  victims: number /* int */;
  position: number /* int */; // клетка на доске; в режиме free всегда 0
}
/**
 * Settings — настройки партии, фиксируемые на старте.
 */
export interface Settings {
  mode: Mode;
  maxIntensity: number /* int */;
}
/**
 * Pending — вытянутая карточка, ожидающая разрешения.
 */
export interface Pending {
  cardId: string;
  deck: Deck;
  assigneeSeat: number /* int */; // кто исполняет; меняется спасателем
  targetSeats: number /* int */[];
  rescued?: boolean;
}
/**
 * State — полное состояние партии.
 * Состояние принадлежит одной горутине комнаты. Мьютексов здесь нет и быть
 * не должно: синхронизация — через канал команд комнаты.
 */
export interface State {
  schema: number /* int */;
  seed: number /* int64 */;
  deckVersion: string;
  boardVersion?: string;
  settings: Settings;
  players: Player[];
  activeSeat: number /* int */;
  turn: number /* int */;
  phase: Phase;
  pending?: Pending;
  queues: { [key: Deck]: string[]};
}
/**
 * PlayerSpec — заявка на игрока при создании партии.
 * Теги обязательны: структура уезжает в векторы соответствия, а их читает
 * чужая реализация на другом языке.
 */
export interface PlayerSpec {
  id: PlayerID;
  name: string;
  gender?: Gender;
}
/**
 * Config — всё, что нужно, чтобы создать партию.
 */
export interface Config {
  Seed: number /* int64 */;
  Deck?: DeckSet;
  BoardVersion: string;
  Settings: Settings;
  Players: PlayerSpec[];
}
/**
 * DeckSelector решает, из какой категории тянуть следующую карточку.
 * Интерфейс объявлен здесь, на стороне потребителя: реализации живут в
 * internal/board, и обратная зависимость создала бы цикл импортов.
 */
export type DeckSelector = any;
